import { NgModule, Directive, Input, Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'international-phone-number',
  template: ''
})
export class InternationalPhoneNumberComponent {
  @Input() defaultCountry: any;
  @Input() placeholder: any;
  @Input() control: any;
  @Input() required: any;
  @Input() name: any;
  @Input() maxlength: any;
  @Input() formControlName: any;
}

@NgModule({
  declarations: [InternationalPhoneNumberComponent],
  exports: [InternationalPhoneNumberComponent]
})
export class InternationalPhoneNumberModule {}

@Directive({
  selector: '[fileSaver]'
})
export class FileSaverDirective {
  @Input() method: any;
  @Input() fileName: any;
  @Input() url: any;
  @Input() http: any;
  @Output() success = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();
}

@NgModule({
  declarations: [FileSaverDirective],
  exports: [FileSaverDirective]
})
export class FileSaverModule {}

@Component({
  selector: 'ngx-pull-to-refresh',
  template: '<ng-content></ng-content>'
})
export class NgxPullToRefreshComponent {
  @Input() spinnerColor: any;
  @Input() distanceForRefresh: any;
  @Input() isEnable: any;
  @Input() targetElement: any;
  @Input() customClass: any;
  @Output() refresh = new EventEmitter<any>();
}

@NgModule({
  declarations: [NgxPullToRefreshComponent],
  exports: [NgxPullToRefreshComponent]
})
export class NgxPullToRefreshModule {}
